import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import ApiService from 'services/ApiService/ApiService';


export const getEvent = async() => {
  const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

  const ONLINE_EVENT_URL = `${BASE_URL}/rest/v1.0/realityshows/active`;
  const { data } = await ApiService.get(ONLINE_EVENT_URL);

  return data;
};

export const getEventCams = async(eventName) => {
  const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);
  const eventCamsUrl =
    `${BASE_URL}/directoryCams?directoryJson=true&online=true&url=true&resultsPerPage=60&showTag=${eventName}`;

  const { data } = await ApiService.get(eventCamsUrl);

  return data;
};
